import React from "react";
import "./LoadingIcon.css";
import icon from "./icon.png";

function LoadingIcon({animation = null, isLoading = true, className = ""}) {

    const animations = [
        "fa-bounce", "fa-shake", "fa-flip", "fa-beat",
        "fa-beat-fade", "fa-fade", "fa-spin", "fa-spin-pulse"
    ];
    animation = animation || animations[0]

    return (<div className={`loadingIcon ${isLoading ? "animate "+animation : ""} ${className}`}
                 style={{backgroundImage: `url(${icon})`}}></div>);
}

export default LoadingIcon;
